import type { IMetric } from "../api/analytics.api";
import * as AT from "./analytics.constants";

export type AnalyticsActions = IPurgeAnalytics | ISetMetrics;

interface IPurgeAnalytics {
  type: AT.PURGE_ANALYTICS;
}

export const purgeAnalytics = (): IPurgeAnalytics => {
  return { type: AT.PURGE_ANALYTICS };
};

interface ISetMetrics {
  type: AT.SET_METRICS;
  metrics: IMetric[] | null;
}

export const setMetrics = (metrics: IMetric[] | null): ISetMetrics => {
  return {
    type: AT.SET_METRICS,
    metrics
  };
};
